import React from 'react';
import { Check, Boxes, Scale, ClipboardCheck } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const ICONS = [Boxes, Scale, ClipboardCheck];
const METRICS = ['+24% throughput', '100% scale sync', '0 lost audits'];

export default function FeaturesSection() {
  const { t } = useLanguage();

  return (
    <section id="features" className="bg-[#FAF7F2] border-b border-ct-line py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-12 lg:mb-16">
          <p className="text-[11px] font-bold uppercase tracking-widest text-ct-brand mb-3">
            {t.features.subtitle}
          </p>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-black text-ct-ink tracking-tight"
            style={{ fontFamily: 'Chivo, sans-serif' }}
          >
            {t.features.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {t.features.blocks.map((block, i) => {
            const Icon = ICONS[i] || Boxes;
            return (
              <article
                key={i}
                className="ct-card-lift group relative bg-white border border-ct-line rounded-ct-card p-7 flex flex-col ct-shadow-sm"
                data-testid={`feature-card-${i}`}
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-11 h-11 bg-ct-brand-soft text-ct-brand flex items-center justify-center rounded-ct-chip">
                    <Icon className="w-5 h-5" strokeWidth={1.75} />
                  </div>
                  <span
                    className="text-[11px] font-bold uppercase tracking-widest text-ct-ink-3 font-mono"
                    style={{ fontFamily: 'IBM Plex Mono, monospace' }}
                  >
                    {METRICS[i]}
                  </span>
                </div>

                <h3
                  className="text-lg font-black text-ct-ink mb-4 tracking-tight"
                  style={{ fontFamily: 'Chivo, sans-serif' }}
                >
                  {block.title}
                </h3>

                <ul className="space-y-2.5">
                  {block.items.map((item, j) => (
                    <li key={j} className="flex items-center gap-2.5 text-sm text-ct-ink-2">
                      <span className="flex-shrink-0 w-4 h-4 flex items-center justify-center bg-ct-brand/10 rounded-sm">
                        <Check className="w-3 h-3 text-ct-brand" strokeWidth={3} />
                      </span>
                      {item}
                    </li>
                  ))}
                </ul>

                <div
                  aria-hidden="true"
                  className="absolute inset-x-7 bottom-0 h-0.5 bg-ct-brand scale-x-0 origin-left transition-transform duration-300 group-hover:scale-x-100"
                />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
